/* Homepage rebuild v4 (2 Oct 2026). Drives the hp-* homepage sections:
   - the avoid picker (sections/hp-rule-out.liquid): sport switch, chips, free text, max 3 per sport;
   - the buy box (sections/hp-buy-box.liquid): sport tabs swap the box in place, the ruled-out
     row inside each form, the dynamic button label and the line under it;
   - hand-over: shelf tiles, picker button, tabs and every in-page "#products-anywhere-section"
     link scroll smoothly to the box and flash it;
   - the drift wall pauses when off-screen or when the tab is hidden.
   Picks are saved per sport in localStorage ("siab:avoid:<sport>", JSON array) and written as
   "A, B, C" into every properties[Teams to avoid] field of that sport's box, the format the live
   filter popup uses.
   US port (Website-US): the buy box is the US Ultimate Buy Box 2 (assets/ultimate-products-anywhere2.js),
   whose shared form snippet is left untouched. So this file adds the ruled-out row and the line under
   the button to each form itself, and pre-fills the popup's teams box from the form before the popup
   opens (that script resets the popup and then copies the teams box back into the form). */
(function () {
  'use strict';
  var MAX = 3, SHOW = 12, LS = 'siab:avoid:', LSS = 'siab:sport';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function names(p) {
    p = p.map(function (x) { return '<b>' + esc(x) + '</b>'; });
    return p.length < 2 ? p[0] : p.slice(0, -1).join(', ') + ' and ' + p[p.length - 1];
  }
  function fill(tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return k in map ? map[k] : m; }); }
  function scrollToEl(el) { if (el) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }

  /* US: the shared US form has no homepage hooks, so add them here. The ruled-out row goes above the
     purchase options, the line goes under the add button. */
  function addFormBits(buybox) {
    if (!buybox) return;
    var label = buybox.dataset.ruledLabel || 'Ruled out';
    buybox.querySelectorAll('.hp-sport-box form[action$="/cart/add"]').forEach(function (f) {
      if (!f.querySelector('[data-hp-ruled]')) {
        var row = document.createElement('div');
        row.className = 'hp-ruled'; row.hidden = true;
        row.setAttribute('data-hp-ruled', ''); row.setAttribute('aria-live', 'polite');
        var lab = document.createElement('p'); lab.className = 'variant__label'; lab.textContent = label;
        var tags = document.createElement('div'); tags.className = 'hp-ruled__tags'; tags.setAttribute('data-hp-ruled-tags', '');
        row.appendChild(lab); row.appendChild(tags);
        var anchor = f.querySelector('.ub-plan-picker');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(row, anchor); else f.insertBefore(row, f.firstChild);
      }
      if (!f.querySelector('[data-hp-under]')) {
        var u = document.createElement('p');
        u.className = 'hp-under'; u.hidden = true;
        u.setAttribute('data-hp-under', ''); u.setAttribute('aria-live', 'polite');
        var btn = f.querySelector('button[name="add"]');
        if (btn && btn.parentNode) btn.parentNode.insertBefore(u, btn.nextSibling); else f.appendChild(u);
      }
    });
  }

  function init() {
    var buybox = document.querySelector('[data-hp-buybox]');
    addFormBits(buybox);
    var cfgEl = document.getElementById('hp-picker-config');
    var cfg = null;
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = null; } }
    var SP = (cfg && cfg.sports) || {};

    var keys = [];
    document.querySelectorAll('.hp-sport-box[data-hp-sport]').forEach(function (b) { keys.push(b.dataset.hpSport); });
    Object.keys(SP).forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); });
    if (!keys.length) return;

    var picks = {}, expanded = {};
    keys.forEach(function (k) {
      var v = null; try { v = JSON.parse(lsGet(LS + k)); } catch (e) {}
      picks[k] = Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x; }).slice(0, MAX) : [];
    });
    var saved = lsGet(LSS);
    var cur = keys.indexOf(saved) > -1 ? saved : keys[0];

    function box(s) { return document.querySelector('.hp-sport-box[data-hp-sport="' + s + '"]'); }
    function boxName(s) { return (SP[s] && SP[s].boxName) || s; }
    var removeTpl = (cfg && cfg.removeLabel) || 'Put {team} back in';

    function tag(c, fn) {
      var t = document.createElement('button');
      t.type = 'button'; t.className = 'hp-tag';
      t.setAttribute('aria-label', fill(removeTpl, { team: c }));
      t.textContent = c + ' ';
      var b = document.createElement('b'); b.setAttribute('aria-hidden', 'true'); b.innerHTML = '&times;';
      t.appendChild(b); t.onclick = fn; return t;
    }

    /* ---------- buy box ---------- */
    var bbData = buybox ? buybox.dataset : {};
    function write(s) {
      var p = picks[s], v = p.join(', '), b = box(s);
      lsSet(LS + s, JSON.stringify(p));
      if (!b) return;
      b.querySelectorAll('form input[name="properties[Teams to avoid]"]').forEach(function (i) { i.value = v; });
      b.querySelectorAll('[data-hp-ruled]').forEach(function (row) {
        var t = row.querySelector('[data-hp-ruled-tags]'); t.innerHTML = '';
        p.forEach(function (c) { t.appendChild(tag(c, function () { toggleIn(s, c); })); });
        row.hidden = !p.length;
      });
      b.querySelectorAll('form[action$="/cart/add"]').forEach(function (f) {
        var btnText = f.querySelector('[id^="AddToCartText-"]');
        var btn = f.querySelector('.add-to-cart');
        if (btnText && btn && !btn.disabled) btnText.textContent = p.length ? bbData.ctaPicks : bbData.ctaEmpty;
        var u = f.querySelector('[data-hp-under]');
        if (u) {
          u.innerHTML = p.length ? fill(p.length > 1 ? bbData.lineMany : bbData.lineOne, { names: names(p) }) : '';
          u.hidden = !p.length;
        }
      });
    }

    /* ---------- picker ---------- */
    var picker = document.querySelector('[data-hp-picker]');
    var chipsEl = document.getElementById('hp-ban-chips'), tags = document.getElementById('hp-ban-tags');
    var empty = document.getElementById('hp-ban-empty'), go = document.getElementById('hp-ban-go');
    var addIn = document.getElementById('hp-add-in'), addBtn = document.getElementById('hp-add-btn');

    function renderChips() {
      if (!picker || !SP[cur]) return;
      var o = SP[cur].opts || [], lim = (o.length > 15 && !expanded[cur]) ? SHOW : o.length;
      chipsEl.innerHTML = '';
      o.slice(0, lim).forEach(function (n) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'hp-chip';
        b.dataset.club = n; b.textContent = n; b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { toggle(n); });
        chipsEl.appendChild(b);
      });
      if (lim < o.length) {
        var m = document.createElement('button'); m.type = 'button'; m.className = 'hp-chip hp-chip--more';
        m.textContent = fill(cfg.showAll, { n: o.length, what: SP[cur].more || 'teams' });
        m.addEventListener('click', function () { expanded[cur] = true; renderChips(); render(); });
        chipsEl.appendChild(m);
      }
      document.getElementById('hp-ban-h').textContent = SP[cur].h;
      document.getElementById('hp-ban-sub').innerHTML = '<span class="hp-ban__sport">' + esc(SP[cur].label) + ':</span> ' + esc(SP[cur].help) + ' ' + esc(cfg.limitLine || '');
      addIn.placeholder = SP[cur].add || '';
      document.getElementById('hp-ban-small').textContent = fill(cfg.small, { box: boxName(cur) });
    }

    function render() {
      var p = picks[cur];
      if (picker && SP[cur]) {
        tags.innerHTML = '';
        p.forEach(function (c) { tags.appendChild(tag(c, function () { toggle(c); })); });
        empty.style.display = p.length ? 'none' : 'block';
        chipsEl.querySelectorAll('.hp-chip:not(.hp-chip--more)').forEach(function (ch) {
          var on = p.indexOf(ch.dataset.club) > -1;
          ch.setAttribute('aria-pressed', on ? 'true' : 'false');
          ch.disabled = !on && p.length >= MAX;
        });
        var full = p.length >= MAX;
        addIn.disabled = full; addBtn.disabled = full;
        go.firstElementChild.textContent = p.length ? fill(full ? cfg.btnFull : cfg.btnSome, { box: boxName(cur) }) : cfg.btnNone;
      }
      write(cur);
    }
    function toggle(c) {
      var p = picks[cur], i = p.indexOf(c);
      if (i > -1) p.splice(i, 1); else if (p.length < MAX) p.push(c);
      render();
    }
    function toggleIn(s, c) {
      var p = picks[s], i = p.indexOf(c);
      if (i > -1) p.splice(i, 1);
      if (s === cur) render(); else write(s);
    }

    function setSport(s) {
      if (keys.indexOf(s) < 0) return;
      cur = s; lsSet(LSS, s);
      document.querySelectorAll('.hp-sport-box').forEach(function (b) {
        var on = b.dataset.hpSport === s;
        b.hidden = !on;
        if (on && !b.querySelector('.product-section:not(.tw-hidden)')) {
          var first = b.querySelector('.product-section');
          if (first) first.classList.remove('tw-hidden');
        }
      });
      document.querySelectorAll('#sport-tabs [role=tab]').forEach(function (t) { t.setAttribute('aria-selected', t.dataset.hpSport === s ? 'true' : 'false'); });
      document.querySelectorAll('#hp-sw button').forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.hpSport === s ? 'true' : 'false'); });
      renderChips(); render();
      window.dispatchEvent(new Event('resize'));
    }

    var flashT;
    function handover() {
      var tabs = document.getElementById('sport-tabs') || buybox;
      scrollToEl(tabs);
      var b = box(cur); if (!b) return;
      clearTimeout(flashT); b.classList.add('hp-flash');
      flashT = setTimeout(function () { b.classList.remove('hp-flash'); }, 1600);
    }

    /* The MENS / KIDS toggle in ultimate-products-anywhere2.js hides every product section on the page,
       shows one, and restyles every toggle button on the page. Keep both inside the box that is showing. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-product-toggle]');
      if (!t) return;
      var b = t.closest('.hp-sport-box'); if (!b) return;
      setTimeout(function () {
        document.querySelectorAll('.hp-sport-box').forEach(function (other) {
          if (other === b) return;
          var f = other.querySelector('.product-section');
          if (f && !other.querySelector('.product-section:not(.tw-hidden)')) f.classList.remove('tw-hidden');
          var shown = other.querySelector('.product-section:not(.tw-hidden)');
          var id = shown ? shown.getAttribute('data-section-id') : null;
          other.querySelectorAll('[data-product-toggle]').forEach(function (btn) {
            var on = btn.getAttribute('data-product-toggle') === id;
            btn.classList.toggle('tw-border-[#1c1d1d]', on);
            btn.classList.toggle('tw-border-[#E6E6E6]', !on);
          });
        });
      }, 0);
    });

    /* Show the filter popup's options for the sport whose form opened it (capture phase, so this
       runs before ultimate-products-anywhere2.js opens and resets the popup). US: the teams box is
       pre-filled through its default value, so the popup's reset() keeps the picks in it. */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action$="/cart/add"]')) return;
      var b = f.closest('.hp-sport-box'); if (!b) return;
      var s = b.dataset.hpSport, group = null;
      document.querySelectorAll('[data-hp-opt-group]').forEach(function (g) {
        var on = g.dataset.hpOptGroup === s; g.hidden = !on; if (on) group = g;
      });
      var ta = document.getElementById('specific-teams');
      if (ta) {
        if (group && group.dataset.teamsPh) ta.placeholder = group.dataset.teamsPh;
        var field = f.querySelector('input[name="properties[Teams to avoid]"]');
        ta.defaultValue = field ? field.value : '';
      }
    }, true);

    /* Wire up */
    keys.forEach(function (k) { if (k !== cur) write(k); });
    document.querySelectorAll('#sport-tabs [role=tab]').forEach(function (t) {
      t.addEventListener('click', function () { setSport(t.dataset.hpSport); handover(); });
    });
    document.querySelectorAll('#hp-sw button').forEach(function (t) {
      t.addEventListener('click', function () { setSport(t.dataset.hpSport); });
    });
    document.querySelectorAll('.hp-tile[data-hp-sport]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!buybox || !box(a.dataset.hpSport)) return;
        e.preventDefault(); setSport(a.dataset.hpSport); handover();
      });
    });
    if (go) go.addEventListener('click', function (e) { if (buybox) { e.preventDefault(); handover(); } });
    var addForm = document.getElementById('hp-add');
    if (addForm) addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = addIn.value.replace(/\s+/g, ' ').trim().replace(/,/g, '');
      if (!v) return;
      var p = picks[cur]; if (p.length >= MAX) return;
      if (!p.some(function (x) { return x.toLowerCase() === v.toLowerCase(); })) p.push(v);
      addIn.value = ''; render();
    });
    /* In-page links: smooth scroll; anything pointing at the buy box hands over. */
    document.querySelectorAll('a[href*="#"]').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      var hash = h.slice(h.indexOf('#'));
      var path = h.slice(0, h.indexOf('#'));
      if (path && path !== '/' && path !== location.pathname) return;
      if (hash === '#products-anywhere-section' || hash === '#sport-tabs') {
        if (!buybox) return;
        a.addEventListener('click', function (e) { if (e.defaultPrevented) return; e.preventDefault(); handover(); });
      } else if (['#sport-shelf', '#rule-out', '#recent-pulls', '#collectors', '#founder', '#as-seen-with'].indexOf(hash) > -1) {
        a.addEventListener('click', function (e) {
          var t = document.getElementById(hash.slice(1)); if (!t) return;
          e.preventDefault(); scrollToEl(t);
        });
      }
    });

    window.hpHome = { setSport: setSport, picks: picks, current: function () { return cur; }, handover: handover };
    setSport(cur);
  }

  /* Drift wall: pause off-screen and when the tab is hidden. */
  function drift() {
    document.querySelectorAll('[data-hp-drift]').forEach(function (rp) {
      var vis = true;
      function set() { rp.classList.toggle('paused', !vis || document.hidden); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { vis = e[0].isIntersecting; set(); }).observe(rp);
      document.addEventListener('visibilitychange', set);
    });
  }

  /* As seen with: muted inline loops that play only while on screen. Reduced motion: poster only. */
  function clips() {
    var vids = document.querySelectorAll('.hp-clip__media video');
    if (!vids.length) return;
    var wide = window.matchMedia('(min-width: 768px)').matches;
    vids.forEach(function (v) {
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
      var src = wide ? v.dataset.srcHd : v.dataset.srcSd;
      if (src && v.dataset.srcSd) v.src = src;
    });
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !document.hidden) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function boot() { init(); drift(); clips(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
